import { BaseEnum } from "../BaseEnum";

// UI badge state shown for each document in the bulk facility-matching review.
// Derived in the view from the document lifecycle (RUNNING/VERIFIED) and the
// backend match outcome (AUTO/FALLBACK/UNASSIGNED). Not persisted.
export class DsrFacilityMatchStatus extends BaseEnum {
  static RUNNING = "running";
  static VERIFIED = "verified";
  static UNASSIGNED = "unassigned";
  static FALLBACK = "fallback";
  static AUTO = "auto";

  static Codes = [
    this.RUNNING,
    this.VERIFIED,
    this.UNASSIGNED,
    this.FALLBACK,
    this.AUTO,
  ];

  static _labelKeys = [
    "dsr-match-running",
    "dsr-match-verified",
    "dsr-match-to-assign",
    "dsr-match-fallback",
    "dsr-match-auto",
  ];

  static getColor(code) {
    const colors = {
      [this.RUNNING]: "techBlue",
      [this.VERIFIED]: "grey",
      [this.UNASSIGNED]: "error",
      [this.FALLBACK]: "warning",
      [this.AUTO]: "success",
    };
    return colors[code] || "grey";
  }
}
